import { render } from "./ChildrenBasic.vue?vue&type=template&id=683974ae&scoped=true&ts=true"
import script from "./ChildrenBasic.vue?vue&type=script&lang=ts"
export * from "./ChildrenBasic.vue?vue&type=script&lang=ts"

import "./ChildrenBasic.vue?vue&type=style&index=0&id=683974ae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683974ae"]])

export default __exports__